import styled from '@emotion/styled';
import { Modal } from 'antd';

import { colorConstants } from 'config/colorConstants';

export const StyledResetInputsModal = styled(Modal)`
    &.price-simulator-v3-reset-inputs-modal {
        width: 520px !important;
        max-width: calc(100vw - 32px);
    }

    .ant-modal-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 8px;
        background: ${colorConstants.white};
        box-shadow: ${colorConstants.modalContentShadow};
        padding: 20px 24px;
    }

    .ant-modal-header {
        width: 100%;
        margin-bottom: 8px;
        padding: 0;
        border-bottom: none;
        background: transparent;
    }

    .ant-modal-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: ${colorConstants.greyAlt20};
    }

    .ant-modal-close {
        top: 20px;
        inset-inline-end: 20px;
    }

    .ant-modal-close-x {
        width: 24px;
        height: 24px;
        line-height: 24px;
        color: ${colorConstants.greyAlt14};
    }

    .ant-modal-body {
        width: 100%;
        padding: 0;
        margin-bottom: 12px;
    }

    .ant-modal-footer {
        width: 100%;
        margin: 0;
        padding: 0;
        border-top: none;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }

    .ant-modal-footer .ant-btn {
        height: 32px;
        font-size: 14px;
        padding-inline: 15px;
    }

    .ant-modal-footer .ant-btn-default {
        border-radius: 6px;
        border: 1px solid ${colorConstants.toolbarBorderGrey};
        background: ${colorConstants.white};
        color: ${colorConstants.greyAlt20};
        font-weight: 600;
        box-shadow: ${colorConstants.buttonDefaultShadow};
    }

    .ant-modal-footer .ant-btn-default:hover,
    .ant-modal-footer .ant-btn-default:focus {
        color: ${colorConstants.greyAlt20};
        border-color: ${colorConstants.toolbarBorderGrey};
        background: ${colorConstants.white};
    }

    .ant-modal-footer .ant-btn + .ant-btn,
    .ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
        margin-inline-start: 0 !important;
        margin-left: 0 !important;
    }

    .ant-modal-footer .ant-btn-primary {
        margin-inline-start: 0 !important;
        margin-left: 0 !important;
        min-width: 68px;
        border-radius: 8px;
        border: 1px solid ${colorConstants.violet};
        background: ${colorConstants.violet};
        font-weight: 400;
        box-shadow: 0 2px 0 0 ${colorConstants.controlOutline};
    }

    .ant-modal-footer .ant-btn-primary:hover,
    .ant-modal-footer .ant-btn-primary:focus {
        color: ${colorConstants.white};
        border-color: ${colorConstants.violet};
        background: ${colorConstants.violet};
    }
`;

export const StyledResetInputsModalBody = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    color: ${colorConstants.greyAlt20};
    text-align: left;
`;
